import queryString from 'query-string';
import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { fromB64 } from 'src/utils/functiones';

const useQueryString = () => {
  const location = useLocation();
  const params = useMemo(() => {
    const qParams = queryString.parse(location.search);
    
    if (qParams?.query) {
      const query = fromB64(qParams?.query);
      return {
        ...qParams,
        ...query,
      };
    }
    return qParams;
  }, [location.search]);
  return params;
};

export default useQueryString;
